export default class SlotCounter {
  static readonly registry = {}

  private static ensureSlot(slot: SlotClass): void {
    // Ensure the <slot> field exists on the registry object
    if (SlotCounter.registry[slot] === undefined) {
      SlotCounter.registry[slot] = 0
    }
  }

  /**
   * Bumps the count of successfully rendered slots of this id
   */
  public static increment(slot: SlotClass): number {
    SlotCounter.ensureSlot(slot)
    return ++SlotCounter.registry[slot]
  }

  /**
   *   Returns number of rendered slots of this id + 1.  That is what is the expected
   * next value.
   */
  public static nextAvailable(slot: SlotClass): number {
    return SlotCounter.total(slot) + 1
  }

  /**
   * Returns number of slots of this id that have been rendered, creates
   * a slot entry for this id if it doesn't exist
   */
  public static total(slot: SlotClass): number {
    SlotCounter.ensureSlot(slot)
    return SlotCounter.registry[slot]
  }
}
